module.exports = __webpack_public_path__ + "static/media/slider-l5-360.e294667f.webp";